import React from 'react';
import { ExpandableTabs } from 'src/components/JobDatasheet/ExpandableTabs';
import { ExternalUserRightSideSectionPropTypes } from 'src/components/JobDatasheet/propTypes';
import { noop } from 'src/utils/core/event';
import { InfoOverlay } from 'src/components/JobDatasheet/InfoOverlay';
import s from 'src/components/JobDatasheet/JobDatasheetForm/JobDatasheetForm.styles';

const ExternalUserRightSideSection = (props) => {

  const {
    activeQuestion,
    activeReportReviewComments,
    activeReportReviewNote,
    datasheetCurrentVersionId,
    datasheetId,
    getResult,
    getResultExternalAttachments,
    hasOpenNoteForExternalUser,
    hasSaqService,
    hasUnverifiedSaqService,
    isReportReviewer,
    isInfoCollapsed,
    isSidebarExpanded,
    isUnderReviewing,
    job,
    onDeletingExternalAttachment,
    readonly,
    refetchReportReview,
    setIsInfoCollapsed,
    setResult,
    setShowHistory,
    setShowNote,
    setShowResult,
    showNote,
    showResult,
    userIsAuthorizedExternalSaqUser,
  } = props;

  return (
    <>
      <s.Right>
        <ExpandableTabs
          disableReviewNotesButton={!hasOpenNoteForExternalUser}
          disableMoreInfoButton={true}
          retryAutoSave={noop}
          retrying={false}
          saveFailedQuestions={[]}
          setIsInfoCollapsed={setIsInfoCollapsed}
          setShowHistory={noop}
          setShowNote={setShowNote}
          setShowResult={noop}
        />
      </s.Right>

      {!!activeQuestion && (showNote || !isInfoCollapsed) && <InfoOverlay
        activeQuestion={activeQuestion}
        activeReportReviewComments={activeReportReviewComments}
        activeReportReviewNote={activeReportReviewNote}
        addNote={noop}
        datasheetCurrentVersionId={datasheetCurrentVersionId}
        datasheetId={datasheetId}
        forExternalUsersOnly={true}
        getResult={getResult}
        getResultAttachments={noop}
        getResultExternalAttachments={getResultExternalAttachments}
        hasSaqService={hasSaqService}
        hasUnverifiedSaqService={hasUnverifiedSaqService}
        isCreateNote={false}
        isInfoCollapsed={isInfoCollapsed}
        isReportReviewer={false}
        isSidebarExpanded={isSidebarExpanded}
        isUnderReviewing={isUnderReviewing}
        jobId={job.id}
        onDeletingExternalAttachment={onDeletingExternalAttachment}
        readonly={readonly}
        refetchReportReview={refetchReportReview}
        resultHistories={null}
        setIsCreateNote={noop}
        setIsInfoCollapsed={setIsInfoCollapsed}
        setResult={setResult}
        setShowNote={setShowNote}
        setShowResult={noop}
        showHistory={false}
        showNote={showNote}
        showResult={showResult}
        userIsAuthorizedExternalSaqUser={userIsAuthorizedExternalSaqUser}
      />}
    </>
  );
};

ExternalUserRightSideSection.propTypes = ExternalUserRightSideSectionPropTypes;

export default React.memo(ExternalUserRightSideSection);
